import { AlertTriangle, X } from 'lucide-react'
import logger from './../../../../utils/logger.js';


export default function ConfirmationDialog({ isOpen, onClose, onConfirm, modalType, cancelCallback, leaveCall, submitHLDSolution }) {
  if (!isOpen) return null;

  const getModalContent = () => {
    switch (modalType) {
      case "end_call":
        return {
          title: (
            <div className="flex items-center gap-2">
              <span className="text-red-500">End</span>
              <span className="text-[#1a365d]">interview call</span>
            </div>
          ),
          heading: "Are you sure you want to end this interview call?",
          message:
            "This interview will be concluded and you won't be allowed to join back in this call. Are you sure about ending this call?",
          confirmText: "Yes, end this call",
          cancelText: "No, remain in this call",
        };
      // case "submit_code":
      //   // Check if we're in Excalidraw context by looking for "drawing" keyword in cancelText
      //   const isHLDDiagram = cancelCallback === undefined && modalType === "submit_code";
      //   return {
      //     title: (
      //       <div className="flex items-center gap-2">
      //         <span className="text-blue-500">Submit</span>
      //         <span className="text-[#1a365d]">{isHLDDiagram ? "HLD diagram" : "code solution"}</span>
      //       </div>
      //     ),
      //     heading: isHLDDiagram ? "Submit your HLD diagram?" : "Submit your code solution?",
      //     message: isHLDDiagram
      //       ? "Are you sure you want to submit your architecture diagram? You won't be able to make further changes after submission."
      //       : "Are you sure you want to submit your code? You won't be able to make further changes after submission.",
      //     confirmText: isHLDDiagram ? "Yes, submit diagram" : "Yes, submit code",
      //     cancelText: isHLDDiagram ? "No, continue drawing" : "No, continue editing",
      //   }
      case "submit_code":
        return {
          title: (
            <div className="flex items-center gap-2">
              <span className="text-blue-500">Submit</span>
              <span className="text-[#1a365d]">code solution</span>
            </div>
          ),
          heading: "Submit your code solution?",
          message:
            "Are you sure you want to submit your code? You won't be able to make further changes after submission.",
          confirmText: "Yes, submit code",
          cancelText: "No, continue editing",
        };
      case "skip_question":
        // Check if we're in Excalidraw context
        const isHLDQuestion =
          cancelCallback === undefined && modalType === "skip_question";
        return {
          title: (
            <div className="flex items-center gap-2">
              <span className="text-yellow-500">Skip</span>
              <span className="text-[#1a365d]">question</span>
            </div>
          ),
          heading: isHLDQuestion
            ? "Skip this HLD question?"
            : "Skip this question?",
          message: isHLDQuestion
            ? "Are you sure you want to skip this system design question? You won't be able to return to it later."
            : "Are you sure you want to skip this question? You won't be able to return to it later.",
          confirmText: "Yes, skip question",
          cancelText: isHLDQuestion
            ? "No, continue designing"
            : "No, continue solving",
        };
      case "hint_selection":
        return {
          title: (
            <div className="flex items-center gap-2">
              <span className="text-purple-500">Select</span>
              <span className="text-[#1a365d]">hint type</span>
            </div>
          ),
          heading: "What type of hint do you need?",
          message:
            "Choose between an approach hint to help with your solution strategy, or a debug hint to help find issues in your current code.",
          confirmText: "Debug Hint",
          cancelText: "Approach Hint",
        };
    }
  }

  const modalContent = getModalContent()

  if (!modalContent) return null;

  const handleModalClick = (e) => {
    e.stopPropagation();
  };

  const handleConfirmClick = (e) => {
    logger.debug("button clicked");
    e.preventDefault();
    e.stopPropagation();
    
    logger.debug('Confirm button clicked for:', modalType);
    
    // Just like CodeEditor, call the appropriate function based on modalType
    if (modalType === "submit_code") {
      // If submitHLDSolution is provided, it should be an HLD diagram submission
      if (submitHLDSolution) {
        logger.debug('Directly calling submitHLDSolution function');
        submitHLDSolution();
      } else {
        // Regular code submission
        logger.debug('Calling onConfirm for code submission');
        onConfirm();
      }
    } else if (modalType === "skip_question") {
      logger.debug('Calling onConfirm for skip question');
      onConfirm();
    } else if (modalType === "hint_selection") {
      logger.debug('Calling onConfirm for hint selection');
      onConfirm();
    } else if (modalType === "end_call") {
      logger.debug('Calling onConfirm and leaveCall for end call');
      onConfirm();
      leaveCall();
    }
    
    onClose();
  };

  return (
    <div
      className="fixed inset-0 bg-black/50 flex items-center justify-center p-4"
      style={{ zIndex: 9999 }}
      onClick={onClose}
    >
      <div
        className="bg-white rounded-[20px] flex flex-col overflow-hidden"
        onClick={handleModalClick}
        style={{
          width: window.innerWidth < 700 ? "90%" : "500px",
          height: window.innerWidth < 700 ? "auto" : "240px",
          borderRadius: "20px !important",
          top: window.innerWidth < 700 ? "65%" : "190px",
          left: window.innerWidth < 700 ? "50%" : "auto",
          transform: window.innerWidth < 700 ? "translate(-50%, -50%)" : "none",
          position: "absolute",
          boxShadow: "0px 25px 50px -12px #00000040, 1px #1118271A",
        }}
      >
        <div
          className="flex items-center justify-between"
          style={{
            width: "100%",
            height: window.innerWidth < 700 ? "40px" : "48px",
            padding: window.innerWidth < 700 ? "8px 12px" : "8px 16px",
            gap: "0px",
            borderBottom: "1px solid var(--gray-200, #E5E7EB)",
            background: "var(--base-White, #FFFFFF)",
          }}
        >
          <div className="flex items-center gap-2 ">
            {modalType === "end_call" ? (
              <AlertTriangle className="text-red-500 h-4 w-4" />
            ) : modalType === "submit_code" ? (
              <span className="text-blue-500">📝</span>
            ) : null}
            {modalContent.title}
          </div>
          <div className="flex items-center gap-2">
            <span className="px-3 py-1 bg-gray-100 rounded-lg text-gray-600 text-sm">
              esc
            </span>
            <button
              onClick={(e) => {
                e.stopPropagation();
                onClose();
              }}
              className="text-gray-400 hover:text-gray-600"
            >
              <X className="h-6 w-6" />
            </button>
          </div>
        </div>
        <div className="space-y-4 mb-6">
          <h2
            className="text-[20px] font-medium leading-[30px] text-gray-800"
            style={{
              width: "90%",
              height: "auto",
              gap: "0px",
              fontFamily: "Inter, sans-serif",
              fontSize: window.innerWidth < 700 ? "18px" : "20px",
              fontWeight: "500",
              lineHeight: window.innerWidth < 700 ? "24px" : "30px",
              letterSpacing: "-0.5px",
              textAlign: "left",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",
              marginLeft: "12px",
              marginTop: window.innerWidth < 700 ? "8px" : "10px",
              padding: window.innerWidth < 700 ? "0 8px" : "0",
            }}
          >
            {modalContent.heading}
          </h2>
          <p
            className="text-gray-600 text-lg"
            style={{
              width: "90%",
              height: "auto",
              gap: "0px",
              fontFamily: "Inter, sans-serif",
              fontSize: window.innerWidth < 700 ? "14px" : "16px",
              fontWeight: "400",
              lineHeight: window.innerWidth < 700 ? "20px" : "24px",
              letterSpacing: "-0.3px",
              textAlign: "left",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",
              marginLeft: "12px",
              padding: window.innerWidth < 700 ? "0 8px 16px 8px" : "0",
            }}
          >
            {modalContent.message}
          </p>
        </div>
        <div
          className="flex gap-4 items-stretch"
          style={{
            width: "100%",
            height: "auto",
            padding: window.innerWidth < 700 ? "12px 8px" : "16px",
            gap: window.innerWidth < 700 ? "8px" : "10px",
            background: "var(--Gray-100, #EEEEF0)",
          }}
        >
          <button
            onClick={(e) => {
              e.preventDefault();
              if (cancelCallback && modalType === "hint_selection") {
                cancelCallback();
              } else {
                // leaveCall();
                onClose();
              }
            }}
            className="flex-1 text-lg font-medium text-gray-800 flex items-center justify-center text-center"
            style={{
              minHeight: window.innerWidth < 700 ? "36px" : "40px",
              padding: window.innerWidth < 700 ? "6px 8px" : "8px 12px",
              fontSize: window.innerWidth < 700 ? "14px" : "16px",
              lineHeight: "1.2", // Reduced line height
              borderRadius: "8px",
              border: "1px solid var(--White, #FFFFFF)",
              background: "var(--White, #FFFFFF)",
              boxShadow:
                "0px 0px 0px 1px #0000001A, 0px 0.5px 1px 0px #0000001F, 0px 2px 6px 0px #00000014",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              wordBreak: "break-word", // Ensures long words wrap properly
              whiteSpace: "normal", // Allows text wrapping
            }}
          >
            {modalContent.cancelText}
          </button>
          <button
            onClick={handleConfirmClick}
            className="flex-1 text-lg font-medium text-white flex items-center justify-center text-center"
            style={{
              minHeight: window.innerWidth < 700 ? "36px" : "40px",
              padding: window.innerWidth < 700 ? "6px 8px" : "8px 12px",
              fontSize: window.innerWidth < 700 ? "14px" : "16px",
              lineHeight: "1.2", // Reduced line height
              borderRadius: "8px",
              border:
                modalType === "end_call"
                  ? "1px solid var(--Red-300, #FCA5A5)"
                  : "1px solid var(--Blue-300, #93C5FD)",
              background:
                modalType === "end_call"
                  ? "linear-gradient(0deg, var(--Red-600, #DC2626), var(--Red-600, #DC2626)), linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%)"
                  : "linear-gradient(0deg, var(--Blue-600, #2563EB), var(--Blue-600, #2563EB)), linear-gradient(180deg, rgba(255, 255, 255, 0.24) 0%, rgba(255, 255, 255, 0) 100%)",
              boxShadow:
                "0px 6px 13px 0px #00000026, 0px 23px 23px 0px #00000021, 0px 53px 32px 0px #00000014, 0px 94px 38px 0px #00000005, 0px 147px 41px 0px #00000000",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              wordBreak: "break-word", // Ensures long words wrap properly
              whiteSpace: "normal", // Allows text wrapping
            }}
          >
            {modalContent.confirmText}
          </button>
        </div>
      </div>
    </div>
  );
}

